import { find, map, reduce, some } from 'lodash-es';
import { Offer } from './../offers.service';

export default class OfferHelperService {
  model: any = null;
  offersStatus: any = [];
  unsubscribe: any;

  /**
   * Yes, our helper can have a helper. Previously this helper only looked at the information on a given offer to
   * determine whether the pricing status was complete or not. But on the Offer Pricing page, that's a dynamic
   * thing. It can change as we add/remove prices from the cells. Thus, by setting this we can give the
   * OfferHelper something it can call to determine whether a given offer is priced or not.
   *
   * @param model
   */
  setRealTimeCompletionHelper(model) {
    if (model) {
      this.model = model;
      this.unsubscribe = this.model.store.subscribe(() => {
        let state = this.model.store.getState();
        this.offersStatus = new Array();
        state.offers.forEach((offer, index) => {
          this.offersStatus.push({
            id: offer.id,
            isComplete: this.model.isComplete(offer.id)
          });
        });
      });
    }
  }

  /**
   * Updates the offer to indicate whether the structure is complete
   *
   * @param {offer[]} offers The list of offers passed to this component
   */

  updateOffers(offers) {
    //
  }

  /**
   * Checks if the structure is complete for an offer
   *
   * @param {offer} offer
   */
  isStructureComplete(offer) {
    let hasDurations = some(offer.term.durations, {
      supports: true
    });

    let hasPricingTypes = some(offer.term.pricingTypes, {
      supports: true
    });

    return hasDurations && hasPricingTypes;
  }

  /**
   * Is pricing complete for an offer?
   *
   * @param {offer} offer
   */
  isPricingComplete(offer) {
    if (this.model !== null && this.model !== undefined) {
      let modelStatus = find(this.offersStatus, { id: offer.id }) as any;

      if (modelStatus !== undefined) {
        let modelComplete = modelStatus.isComplete;

        if (modelComplete !== undefined) {
          return modelComplete;
        }
      }
    }

    return offer.productPricingStatus == 'COMPLETE';
  }

  /**
   * We show the offer as complete if each of the following is complete:
   * - Structure
   * - Lead Time (this is always complete)
   * - Pricing
   *
   * @param {offer} offer
   */
  isOfferComplete(offer) {
    if (!offer) {
      return false;
    }

    return this.isStructureComplete(offer) && this.isPricingComplete(offer);
  }

  /**
   * Get the number of completed offers
   *
   * Improvement: If offers were immutable, we could just watch it and recalculate on change instead of each digest
   * This works as-is, so not worth the effort to optimize at this point
   */
  getNumberOfCompletedOffers(offers) {
    if (!offers) {
      return 0;
    }

    // Create a map of whether each offer is complete or not
    let isCompleteMap = map(offers, (offer) => this.isOfferComplete(offer));

    // Get the total number of completed offers from the map
    return reduce(isCompleteMap, (total, offer) => (total += offer ? 1 : 0), 0);
  }

  /**
   * Get the total number of offers
   */
  getTotalNumberOfOffers(offers) {
    return offers ? offers.length : 0;
  }

  getDisplayStatus(status) {
    switch (status) {
      case 'COMPLETE':
        return 'Complete';
      case 'NO_PRICING':
        return 'None';
      case 'HAS_ERRORS':
        return 'Pricing Errors';
      default:
        return '';
    }
  }

  /**
   * Get the class to show for whether the offer is complete or not
   *
   * @param {offer} offer
   */
  getOfferCompleteClass(offer) {
    let isComplete = this.isOfferComplete(offer);
    if (isComplete) {
      return 'apt-check-circle-icon apt-green';
    } else {
      return 'apt-exclamation-circle-icon apt-red';
    }
  }
}
